import da from 'translations/da.json'
import en from 'translations/en.json'

interface Translations {
  [key: string]: string
}

interface TranslationParams {
  [key: string]: any
  count?: number
}

const translations: { [key: string]: Translations } = {
  da,
  en
}

let lang: string = 'en'

export function t(key: string, params: TranslationParams = {}): string {
  const { count } = params
  if (count !== undefined) {
    if (count === 1) {
      key += '.one'
    } else {
      key += '.other'
    }
  }
  return replaceParams(
    translations[lang][key] || `Missing translation: ${key}`,
    params
  )
}

export function setLang(newLang: string): void {
  lang = newLang
}

export function getLang(): string {
  return lang
}

function replaceParams(s: string, params: TranslationParams): string {
  for (let k in params) {
    s = s.replace(`{{${k}}}`, params[k])
  }
  return s
}

export function popupHandler(store: any): void {
  const check = () => {
    if (window.globalOpenWarningPopup && window.globalOpenWarningPopup.open) {
      store.dispatch({
        type: 'OPEN_WARNING_POPUP',
        payload: window.globalOpenWarningPopup.uncombinables
      })
    }
  }

  store.subscribe(check)
}
